import './footer.css';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../../i18n' // Import i18n configuration

function Footer() {
    const { t } = useTranslation(); // t is the translation function
    return (
    <footer>
    <section className="footer-colored-section" id="foot">
      <div className = "container-fluid">
        <div className="dreamer_footer-links">
          <div className="dreamer_footer-links_logo">
            <a href="/#" className="pull-left"><img src='/Dreamer_new.png' alt="logo" style={{width: "100px", height: "100px"}}></img></a> 
            <h4>Dreamer's Journey</h4>
            <p>Diamond complex, Da Nang, Vietnam <br /> All Rights Reserved</p>
          </div>
          <div className="dreamer_footer-links_div">
            <h4>{t('navigation:footer.information')}</h4>
            <Link style={{ textDecoration: 'none'}} to="/about"><p>{t('navigation:footer.about-us')}</p></Link>
            <p>{t('navigation:footer.partnership')}</p>
            <a style={{ textDecoration: 'none'}} href="https://www.facebook.com/profile.php?id=61567331845801"><p>{t('navigation:footer.socialMedia')}</p></a>
            <p>{t('navigation:footer.blogs/magazine')}</p>
            <Link style={{ textDecoration: 'none'}} to="/support"><p>{t('navigation:footer.contact')}</p></Link>
          </div>
          <div className="dreamer_footer-links_div">
            <h4>{t('navigation:footer.policy')}</h4>
            <p>{t('navigation:footer.terms&Conditions')}</p>
            <p>{t('navigation:footer.privatePolicy')}</p>
            <Link style={{ textDecoration: 'none'}} to="/support"><p>{t('navigation:footer.contact')}</p></Link>
          </div>
          <div className="dreamer_footer-links_div">
            <h4>{t('navigation:footer.contactWithUs')}</h4>
            {/* <a className="item-link" href="https://www.facebook.com/"><i className="social-icon fab fa-facebook-f"></i></a>
            <a className="item-link" href="https://www.facebook.com/"><i className="social-icon fab fa-instagram"></i></a>
            <a className="item-link" href="https://www.facebook.com/"><i className="social-icon fab fa-twitter" ></i></a>
            <a className="item-link" href="https://www.facebook.com/"><i className="social-icon fas fa-envelope"></i></a> */}
            <a style={{ textDecoration: 'none'}} href="https://www.facebook.com/profile.php?id=61567331845801"><p>Facebook</p></a>
            <a style={{ textDecoration: 'none'}} href="https://www.instagram.com/dreamers.journey09"><p>Instagram</p></a>
            <a style={{ textDecoration: 'none'}} href="https://www.tiktok.com/@dreamers.journey"><p>Tiktok</p></a>
            <a style={{ textDecoration: 'none'}} href="https://www.pinterest.com/dreamersjourney09/"><p>Pinterest</p></a>
            <p>Email: Dreamers.Journey09@gmail.com</p>
            <p>{t('navigation:footer.phoneNumber')}: +84 39 620 7199</p>
          </div>
        </div>
        <hr></hr>
        <div className="dreamer_footer-copyright">
          <p>@2020 Dreamer's Journey. All rights reserved.</p>
          {/* <small>Copyright &copy; Duy Minh Pham 2021</small> */}
        </div>
      </div>
    </section>

  </footer>
    )
}

export default Footer;
